<template>
  <nav class="map-filters">
    <FilterRadio v-bind="category" />
    <FilterRadio v-bind="status" />
  </nav>
</template>

<script>
import FilterRadio from '@/components/inputs/FilterRadio.vue'
import { statusNames } from '@/constants'

export default {
  name: 'GoogleMapFilters',
  components: { FilterRadio },
  props: {
    labels: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        category: '',
      },
      category: {
        param: 'category',
        defaultLabel: this.labels.all_categories,
        options: {
          residential: 'Résidentiel',
          commercial: 'Commercial',
          municipal: 'Municipal',
          institutional: 'Institutionnel',
          industrial: 'Industriel',
        },
      },
      status: {
        param: 'status',
        defaultLabel: this.labels.all_status,
        options: statusNames,
      },
    }
  },
}
</script>
